import { filesApi } from '../filesApi'

type SocketTokenResponse = {
  success: boolean
  data: { token: string }
}

export const getSocketToken = async (): Promise<string> => {
  const { data } = await filesApi.post<SocketTokenResponse>('auth')
  return data.data.token
}
